import './styles.sass';

import React, { useState } from 'react';

import PageTitle from 'components/Explorer/PageTitle';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import Chart from './Chart';
import Summary from './Summary';
import Legend from './TimelineChartLegend';
import dayjs from 'util/date';
import useQueryParams from 'hooks/useQueryParams';

const Timeline = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('timeline', params, { reloadOn: ['filters'] });
  const [selectedPostTypes, setSelectedPostTypes] = useState([]);

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;

  const chartData = data?.chart ?? [];
  const legendData = data?.legend ?? [];
  const totalOutputs = data?.total_outputs ?? [];
  const queryDescription = data?.query_description ?? null;
  const latestTimelineDate = dayjs().endOf('day').subtract(1, 'day');

  const content = () => {
    if (loadingFailed)
      return <div className="Explorer-Timeline-error-message">{I18n.t('Explorer.Timeline.error')}</div>;
    if (!chartData.length)
      return <div className="Explorer-Timeline-empty-message">{I18n.t('Explorer.Timeline.empty')}</div>;
    return (
      <div>
        <Legend
          entries={legendData}
          selectedPostTypes={selectedPostTypes}
          updateSelectedPostTypes={setSelectedPostTypes}
        />
        <Chart
          data={chartData}
          selectedPostTypes={selectedPostTypes}
          latestChartDate={latestTimelineDate}
          totalOutputs={totalOutputs}
          queryDescription={queryDescription}
        />
      </div>
    );
  };

  return (
    <div className="Explorer-Timeline">
      <PageTitle metaTitle={I18n.t('Explorer.TabBar.timeline')} />
      <a
        href={I18n.t('Explorer.help.timeline.uri')}
        target="_blank"
        rel="noreferrer"
        title={I18n.t('Explorer.help.timeline.content')}
        className="help"
      >
        {I18n.t('Explorer.help.label_tab')}
      </a>
      <Summary latestChartDate={latestTimelineDate} />
      <div className="Explorer-Timeline-Container">
        {isLoading ? (
          <div className="Explorer-Timeline-loading-message">{I18n.t('Explorer.Timeline.loading')}</div>
        ) : (
          content()
        )}
      </div>
    </div>
  );
};

export default Timeline;
